import { AccountStats } from '@/type';
import api from '@/API';

export default {
  findAccountStats(accountId: number): Promise<AccountStats> {
    return api
      .get(`accounts/${accountId}/stats`)
      .then(response => response.data);
  },
};
